export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13289.6317c1c8.jpg";